// src/pages_unauth/VerifyEmailPage.js
import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import "./VerifyEmailPage.css";
import { ReactComponent as AprendoleIcon } from "../icons/AprendoleIcon5.svg";

import { Capacitor } from "@capacitor/core";

const isNative = Capacitor.isNativePlatform();


export default function VerifyEmailPage() {
  const { user, reloadUser, sendVerificationEmail } = useAuth();
  const navigate = useNavigate();

  const [message, setMessage] = useState("");

  // 🔹 Optional auto-check every few seconds
  useEffect(() => {
    const interval = setInterval(async () => {
      if (user) {
        await reloadUser();
        if (user.emailVerified) {
          clearInterval(interval);
          navigate("/home");
        }
      }
    }, 5000); // check every 5s

    return () => clearInterval(interval);
  }, [user, reloadUser, navigate]);

  const resendVerification = async () => {
    if (user) {
      try {
        await sendVerificationEmail(user);
        setMessage("E-mail de verificação enviado novamente! Verifique sua caixa de entrada.");
      } catch (err) {
        if (err.code === "auth/too-many-requests") {
          setMessage("Você solicitou muitos e-mails. Aguarde alguns minutos e tente novamente.");
        } else {
          setMessage("Erro ao enviar e-mail. Tente novamente mais tarde.");
        }
      }
    }
  };

  const checkVerifiedNow = async () => {
    if (user) {
      await reloadUser();
      if (user.emailVerified) {
        navigate("/home");
      } else {
        setMessage("Ainda não verificado. Verifique sua caixa de entrada.");
      }
    }
  };

    // ─── Mobile layout ────────────────────────────────────────────────────────

  if (!isNative) {
    return (
      <div className="mobile-signup-container">
        <div className="mobile-signup-top">
          <AprendoleIcon className="mobile-signup-logo" />
          <h1 className="mobile-signup-title">Verifique seu e-mail</h1>
        </div>

        <div className="mobile-verify-body">
          <p className="mobile-verify-desc">
            Enviamos um link de verificação para o seu e-mail. Clique no link para ativar sua conta.
          </p>

          <div className="mobile-signup-form">
            <button className="mobile-signup-btn-primary" onClick={checkVerifiedNow}>
              Já verifiquei meu e-mail
            </button>
            <button className="mobile-verify-btn-secondary" onClick={resendVerification}>
              Reenviar e-mail de verificação
            </button>
          </div>

          {message && <p className="mobile-signup-error">{message}</p>}
        </div>

        <div className="mobile-signup-footer">
          <p className="mobile-signup-legal">
            Não recebeu o e-mail? Verifique o spam ou entre em contato:{" "}
            <a href="mailto:contact@aprendole.com" className="mobile-signup-link">
              contact@aprendole.com
            </a>
          </p>
        </div>
      </div>
    );
  }


  return (
    <div className="verify-container">
      <div className="verify-card">
        <h2>Verifique seu e-mail</h2>
        <p>
        Enviamos um link de verificação para o seu e-mail.  
        Clique no link para ativar sua conta.
        </p>

        <button className="verify-button" onClick={resendVerification}>
        Reenviar e-mail de verificação
        </button>

        <button className="verify-button" onClick={checkVerifiedNow}>
        Já verifiquei meu e-mail
        </button>

        {message && <p className="verify-message">{message}</p>}

        <p className="verify-help">
          Não recebeu o e-mail? Verifique o spam ou entre em contato com: contact@aprendole.com.
        </p>
      </div>
    </div>
  );
}

